import axios from 'axios'
import Promise from 'bluebird'
import settings from "settings"
import userToken from 'helpers/userToken'

export default function(path, data) {
	//console.log(settings)
	return new Promise((resolve, reject) => {
		var user = userToken()
		axios.post(
            settings.ep + '/' + path,
            data,
            { headers: { 'Authorization': `Bearer ${user}`} }
        )
        .then(response => {
            if(response.data.status == 200) {
                resolve(response.data)
            }
            else {
                let err = new Error()
                err.message = response.data.message
                err.status = response.data.status
				reject(err)
            }
        })
        .catch(error => {
            reject(error)
        })
	})
}